import type { ContentLibraryProps } from "@rce-web/ui-content-library";
import { useMemo } from "react";
import { useTranslation } from "react-i18next";

type ContentLibraryTranslations = ContentLibraryProps["options"]["i18n"]["translations"];

export function useContentLibraryTranslations() {
  const { t } = useTranslation();

  const translations: ContentLibraryTranslations = useMemo(
    () =>
      t("content-library", {
        returnObjects: true,
      }) as ContentLibraryTranslations,
    [t]
  );

  return translations;
}
